import type { FC } from "react";
import type { ModalProps } from "@uhg-harmony/react";
import { BaseConfirmationModal } from "./BaseConfirmationModal";

type HomeConfirmationModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
};

export const HomeConfirmationModal: FC<HomeConfirmationModalProps> = ({
  title = "Confirm Navigation",
  open,
  onClose,
  onConfirm,
}) => (
  <BaseConfirmationModal
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    title={title}
    bodyText="Are you sure you want to go to Home? Any unsaved changes will be lost."
    confirmLabel="Go to Home"
    confirmVariant="primary"
  />
);
